import {Component, inject} from '@angular/core';
import {NgClass} from '@angular/common';
import {NotificationService} from '@services/frontend/notification.service';
import {LucideAngularModule, X} from '@shared/components/icons/google-icons';

@Component({
  selector: 'app-notification',
  imports: [
    NgClass,
    LucideAngularModule
  ],
  templateUrl: './notification.html',
  styleUrl: './notification.css'
})
export class Notification {

  public notificationService = inject(NotificationService);

  protected readonly X = X;
}
